export function navigateToHome(err) {
  // console.log(err);
  window.open("/", "_self");
};

export function navigateToLink(link, options={}) {
  const { target = "_self" } = options;
  window.open(link, target);
}